import api from "../services/api";

/** @type {Map<string, { blobUrl?: string, mime?: string, ready?: boolean, promise?: Promise<{ blobUrl: string, mime: string }> }>} */
const cache = new Map();
const MAX_ENTRIES = 24;

function cacheKey(expedienteId, nombreArchivo) {
  return `${expedienteId}|${String(nombreArchivo || "").trim()}`;
}

function evictOldest() {
  if (cache.size <= MAX_ENTRIES) return;
  const first = cache.keys().next().value;
  if (!first) return;
  const hit = cache.get(first);
  if (hit?.blobUrl) URL.revokeObjectURL(hit.blobUrl);
  cache.delete(first);
}

/**
 * @returns {{ blobUrl: string, mime: string } | null}
 */
export function obtenerPreviewNasCache(expedienteId, nombreArchivo) {
  const hit = cache.get(cacheKey(expedienteId, nombreArchivo));
  if (hit?.ready && hit.blobUrl) return { blobUrl: hit.blobUrl, mime: hit.mime || "" };
  return null;
}

/**
 * Precarga la vista previa (p. ej. al pasar el ratón sobre la lupa).
 * @returns {Promise<{ blobUrl: string, mime: string }>}
 */
export function prefetchNasPreview(expedienteId, nombreArchivo) {
  const key = cacheKey(expedienteId, nombreArchivo);
  if (!expedienteId || !nombreArchivo) {
    return Promise.reject(new Error("Faltan datos"));
  }

  const existing = cache.get(key);
  if (existing?.ready && existing.blobUrl) {
    return Promise.resolve({ blobUrl: existing.blobUrl, mime: existing.mime || "" });
  }
  if (existing?.promise) return existing.promise;

  const promise = (async () => {
    const r = await api.get(`/expedientes/${expedienteId}/archivos-nas/vista`, {
      params: { nombre: nombreArchivo },
      responseType: "blob",
    });
    const mime = r.headers?.["content-type"] || r.data?.type || "application/octet-stream";
    const blobUrl = URL.createObjectURL(r.data);
    cache.set(key, { blobUrl, mime, ready: true });
    evictOldest();
    return { blobUrl, mime };
  })().catch((err) => {
    cache.delete(key);
    throw err;
  });

  cache.set(key, { promise });
  return promise;
}

export async function parseNasPreviewError(e) {
  let msg = "No se pudo cargar el documento.";
  const data = e.response?.data;
  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text());
      if (parsed?.error) msg = parsed.error;
    } catch {
      /* ignore */
    }
  } else if (data?.error) {
    msg = data.error;
  } else if (e.message) {
    msg = e.message;
  }
  return msg;
}
